// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-layout-container {
  margin-top: 240px;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  padding: 1rem;
  display: flex;
  gap: 2rem;
  position: relative;
}

.other-layout-container {
  min-height: 100vh;
  height: 100%;
  width: 100%;
  padding: 1rem;
  position: relative;
}

.children-container {
  width: 100%;
  height: 100%;
}

.page-routes-nav-container {
  width: 350px;
  position: sticky; /* Changed from relative */
  top: 30px; /* Adjust this value based on your header height */
  align-self: start;
  height: calc(100vh - 240px); /* Subtract header and footer height */
  overflow-y: auto; /* Allow scrolling if content is too long */
  display: none;
}

.page-route-main-container {
  background-color: #ecf8ff;
  padding: 1rem;
  border-radius: 10px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 10;
}

.page-route-main-container h1 {
  font-size: 1rem;
  width: fit-content;
}

.page-route-main-container p {
  font-size: 0.8rem;
}


.header-div-container .header-links-box a{
  color: var(--primary-white);
}

.header-div-container .header-links-box a:hover{
  color: var(--primary-blue);
}

.header-div-container .dropdown-content a{
  color: var(--primary-grey);
}

.header-div-container .dropdown-content a:hover{
  color: var(--primary-blue);
}

.header-links-box.active a{
  color: var(--primary-black2);
}

.header-div-container .hamburger-menu .line{
  background-color: var(--primary-white);
}

.other-layout-container{
  padding: 3rem 20px;
}


@media (min-width: 1024px) {
  .main-layout-container {
    padding: 2rem 4rem;
  }
  .other-layout-container {
    padding: 2rem 4rem;
  }
  .page-routes-nav-container {
    display: block;
  }
}

@media (min-width: 1536px) {
  .main-layout-container {
    padding: 4rem 8rem;
  }
  .other-layout-container {
    padding: 4rem 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/layout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB,EAAE,0BAA0B;EAC5C,SAAS,EAAE,kDAAkD;EAC7D,iBAAiB;EACjB,2BAA2B,EAAE,sCAAsC;EACnE,gBAAgB,EAAE,2CAA2C;EAC7D,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".main-layout-container {\n  margin-top: 240px;\n  min-height: 100vh;\n  height: 100%;\n  width: 100%;\n  padding: 1rem;\n  display: flex;\n  gap: 2rem;\n  position: relative;\n}\n\n.other-layout-container {\n  min-height: 100vh;\n  height: 100%;\n  width: 100%;\n  padding: 1rem;\n  position: relative;\n}\n\n.children-container {\n  width: 100%;\n  height: 100%;\n}\n\n.page-routes-nav-container {\n  width: 350px;\n  position: sticky; /* Changed from relative */\n  top: 30px; /* Adjust this value based on your header height */\n  align-self: start;\n  height: calc(100vh - 240px); /* Subtract header and footer height */\n  overflow-y: auto; /* Allow scrolling if content is too long */\n  display: none;\n}\n\n.page-route-main-container {\n  background-color: #ecf8ff;\n  padding: 1rem;\n  border-radius: 10px;\n  width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.page-route-main-container h1 {\n  font-size: 1rem;\n  width: fit-content;\n}\n\n.page-route-main-container p {\n  font-size: 0.8rem;\n}\n\n\n.header-div-container .header-links-box a{\n  color: var(--primary-white);\n}\n\n.header-div-container .header-links-box a:hover{\n  color: var(--primary-blue);\n}\n\n.header-div-container .dropdown-content a{\n  color: var(--primary-grey);\n}\n\n.header-div-container .dropdown-content a:hover{\n  color: var(--primary-blue);\n}\n\n.header-links-box.active a{\n  color: var(--primary-black2);\n}\n\n.header-div-container .hamburger-menu .line{\n  background-color: var(--primary-white);\n}\n\n.other-layout-container{\n  padding: 3rem 20px;\n}\n\n\n@media (min-width: 1024px) {\n  .main-layout-container {\n    padding: 2rem 4rem;\n  }\n  .other-layout-container {\n    padding: 2rem 4rem;\n  }\n  .page-routes-nav-container {\n    display: block;\n  }\n}\n\n@media (min-width: 1536px) {\n  .main-layout-container {\n    padding: 4rem 8rem;\n  }\n  .other-layout-container {\n    padding: 4rem 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
